/* eslint-disable */
import { triggerEvent } from './functions';

const lndaKitBuilder = () => {
  const addedProducts = [];

  const checkAddToCart = () => {
    const wrapper = document.querySelector('.bundle-cart');
    console.log(addedProducts);
    console.log(addedProducts.length);
    if ( addedProducts.length > 0 ) {
      wrapper.classList.add('visible');
    } else {
      wrapper.classList.remove('visible');
    }
  }

  const updatePrice = (container, newPrice, beforeDiscount = 0) => {
    // Format the price with the correct money format
    const moneyFormat = new Intl.NumberFormat('nb-NO');

    const price = moneyFormat.format(Math.round(newPrice));

    // First try to find the sales price
    let priceContainer = container.querySelector('ins .woocommerce-Price-amount');
    const beforeDiscountPriceContainer = container.querySelector('del .woocommerce-Price-amount');

    if (!priceContainer) {
      priceContainer = container.querySelector('.woocommerce-Price-amount');
    }

    // Create a new element, allowing us to query for the data we need
    const currencyOutput = document.createElement('span');
    currencyOutput.className = 'woocommerce-Price-currencySymbol';

    // Set the currency symbol inside the new output
    currencyOutput.innerText = translation.currency_symbol;

    if (priceContainer) {
      priceContainer.innerText = `${price} `;
      priceContainer.appendChild(currencyOutput);

      if (beforeDiscountPriceContainer) {
        beforeDiscountPriceContainer.innerHTML = `${beforeDiscount} `;
        beforeDiscountPriceContainer.appendChild(currencyOutput.cloneNode(true));
      }
    }
  };


  const productListUpdated = () => {
    const minProductsContainer = document.querySelector('.products-left-for-discount');
    const { minProducts: minLeft, discount } = minProductsContainer.dataset;

    const productsWithCost = addedProducts.filter(product => product.price > 0);
    const left = minLeft - productsWithCost.length;

    let price = 0;

    addedProducts.forEach((product) => {
      price += parseFloat(product.price);
    });

    const regularPrice = document.querySelector('.bundle-info .regular');
    updatePrice(regularPrice, price);

    const salePrice = document.querySelector('.bundle-info .sale');
    const discounted = price * (100 - discount) / 100;
    updatePrice(salePrice, discounted, price);

    if (left >= 1) {
      minProductsContainer.innerText = left;
      minProductsContainer.parentNode.classList.remove('hidden');
      regularPrice.classList.remove('hidden');
      salePrice.classList.add('hidden');
    } else {
      minProductsContainer.parentNode.classList.add('hidden');
      regularPrice.classList.add('hidden');
      salePrice.classList.remove('hidden');
    }

    checkAddToCart();
  };

  const colorScrollButtons = () => {
    const sections = Array.from(document.querySelectorAll('.bundle-section'));

    sections.forEach((section) => {
      const { textColor, color } = section.dataset;
      const buttons = Array.from(section.querySelectorAll('.navigation-button'));

      if (buttons) {
        buttons.forEach((button) => {
          button.style.color = textColor;
          button.style.backgroundColor = color;
          button.innerText = '›';
        });
      }
    });
  };

  const variableProducts = () => {
    const colorPickers = Array.from(document.querySelectorAll('.bundle-section .color-picker'));

    colorPickers.forEach((picker) => {
      picker.addEventListener('click', (event) => {
        event.preventDefault();
        const { section: sectionID, target } = picker.dataset;
        const section = document.getElementById(sectionID);

        const currentSelected = Array.from(section.querySelectorAll('.variable-product-info:not(.hidden)'));

        currentSelected.forEach((selected) => {
          selected.classList.add('hidden');
        });


        const pickerParent = picker.parentNode;
        const currentColor = pickerParent.querySelector('.color-picker.selected');

        if (currentColor) {
          currentColor.classList.remove('selected');
        }

        picker.classList.add('selected');

        const newSelected = Array.from(section.querySelectorAll(`.variable-product-info.${target}`));

        newSelected.forEach((selected) => {
          selected.classList.remove('hidden');
        });
      });
    });
  };

  const selectButtons = () => {
    const buttons = Array.from(document.querySelectorAll('.button.select'));
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();

        const {
          i: sectionId, image, name, id, color, textColor, price,
        } = button.dataset;

        const preCartItem = document.querySelector(`.pre-cart-item.section-${sectionId}`);

        const imageEl = document.createElement('img');
        imageEl.src = image;
        preCartItem.innerHTML = '';
        preCartItem.title = name;
        preCartItem.classList.add('image-added');
        preCartItem.appendChild(imageEl);

        const currentSelected = document.querySelector(`#section-${sectionId} .button.added`);
        const existingIndex = addedProducts.findIndex((existing) => existing.sectionId === sectionId);

        if (currentSelected) {
          currentSelected.innerText = 'velg';
          currentSelected.classList.remove('added');
          currentSelected.style.color = null;
          currentSelected.style.background = null;
          currentSelected.style.borderColor = null;
        }

        if (currentSelected === button) {
          currentSelected.innerText = 'velg';
          currentSelected.classList.remove('added');
          currentSelected.style.color = null;
          currentSelected.style.background = null;
          currentSelected.style.borderColor = null;

          preCartItem.innerText = sectionId;
          preCartItem.title = '';
          preCartItem.classList.remove('image-added');
          addedProducts.splice(existingIndex, 1);
        } else {
          button.innerText = 'lagt til';
          button.classList.add('added');
          button.style.color = textColor;
          button.style.background = color;
          button.style.borderColor = color;

          const data = {
            sectionId,
            image,
            name,
            id,
            color,
            price,
          };

          if (existingIndex >= 0) {
            addedProducts[existingIndex] = data;
          } else {
            addedProducts.push(data);
            addedProducts.sort((a, b) => ((a.sectionId > b.sectionId) ? 1 : -1));
          }
        }

        productListUpdated();
      });
    });

    const addToCartButton = document.querySelector('.bundle-info .button');
    addToCartButton.addEventListener('click', (event) => {
      event.preventDefault();

      if (addedProducts.length === 0) {
        alert('Du må velge minst ett produkt');
        return;
      }

      let containsFree = false;
      addedProducts.forEach((products) => {
        if (products.price === '0') {
          containsFree = true;
        }
      });
      if ( containsFree ) {
        const allGroups = Array.from(document.querySelectorAll('.entry-summary .bundle-section'));
        if ( addedProducts.length !== allGroups.length ) {
          alert('Du må fylle alle gruppene for å få gratis gave');
          return;
        }
      }

      addToCartButton.innerText = 'Legger til…';
      addToCartButton.disabled = true;

      const payload = {
        action: 'lnda_kit_builder_add_to_cart',
        kit: document.body.dataset.postId,
        products: addedProducts,
      };

      jQuery.post(translation.ajaxurl, payload, (response) => {
        addToCartButton.innerText = 'Lagt til';
        addToCartButton.disabled = false;
        triggerEvent(document.body, 'wc_fragment_refresh');
      });
    });

    const toggleCartInfo = document.querySelector('.toggle-bundle-cart-info');
    toggleCartInfo.addEventListener('click', (event) => {
      event.preventDefault();
      document.querySelector('.bundle-cart').classList.toggle('open');
    });
  };

  selectButtons();
  variableProducts();
  setTimeout(() => {
    colorScrollButtons();
  }, 1);
  window.addEventListener('resize', colorScrollButtons);
};

if (document.body.classList.contains('product-type-lnda-kit-builder')) {
  lndaKitBuilder();
}
